export const defaultLineDances = [
  { name: "Set Slide", creator: "Big Mucci" },
  { name: "Cha Cha Slide", creator: "DJ Casper" },
  { name: "Cupid Shuffle", creator: "Cupid" },
  { name: "Wobble", creator: "V.I.C." },
  { name: "So Fly", creator: "Tywana Hilliard" },
  { name: "B'More Nation" },
  { name: "Saturday Mutt", creator: "Irvin Hill" },
  { name: "Dangerous Stuf", creator: "Donald Big Stuff" },
  { name: "Pull Over", creator: "ProducedBy1k" },
  { name: "For Free", creator: "Tyke Matthews" },
  { name: "Move Your Body" },
  { name: "Sexy Wit it", creator: "Classy Hendricks" },
  { name: "Halcyon", creator: "Cessily Greene" },
  { name: "Energy", creator: "TwoSteppers" },
  { name: "Warm Embrace", creator: "Rhonda Dickson" },
  { name: "LDP Walk Thru", creator: "Carlos Vieira Jr." },
  { name: "You", creator: "Shakeema Prescott" },
  { name: "We Outside", creator: "Dani Gunnells-Hall" },
  { name: "Baby What's Happening'", creator: "The A.Y.E. Team" },
  { name: "Work In Progress", creator: "Saykeiya Lumpkin" },
  { name: "Boots on the Ground", creator: "Tre Little" },
  { name: "Heart Of a Woman", creator: "MzNikki Smooth" },
  { name: "Youngstown TuneUp", creator: "Candys Mayo" },
  { name: "Girl Please", creator: "Tina Jackson" },
  { name: "Cree's Nasty", creator: "Christa Roberson" },
  { name: "Drankin' Patna", creator: "Carolyn Scott" },
  { name: "757 LaBella", creator: "Eugena Gordon" },
  { name: "TTP On Chill", creator: "Dee Mayfield" },
  { name: "Wipe Me Down", creator: "Dezert Diamondz" },
  { name: "In My Zone", creator: "Lady D" },
  { name: "Touchin'", creator: "DeMeria SeGuan" },
  { name: "Leave It Smokin'", creator: "Lady D" },
  { name: "Triple VA", creator: "John Woodhouse" },
  { name: "Help Me Find My Drawls", creator: "Mike Lowery" },
  { name: "COD Stepped Into It", creator: "Multiple" },
  { name: "Wayeke Up", creator: "A.Y.E. Team" },
  { name: "All Aboard", creator: "All Snap" },
  { name: "Come Dance With me", creator: "Jo Thompson" },
  { name: "DC Pana", creator: "Pam Nickens" },
  { name: "I want her", creator: "Lena Orr Adams" },
  { name: "Coastin", creator: "Patricia Garner" },
  { name: "Caramel", creator: "Quan & Tiff Nikole" },
  { name: "Oui", creator: "Quan" },
  { name: "Say It", creator: "Nzinga, Vicki, Tasha" },
  { name: "Don't Waste My Time", creator: "Shaunta Porter" },
  { name: "Sweet Love", creator: "Shaunta Porter" },
  { name: "Get UA G", creator: "Tia Cool Beans" },
  { name: "That 150 Water", creator: "Tia Cool Beans" },
  { name: "Shades Guilty", creator: "Chrisy" }
];
